import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBluetoothSearching",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, h, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--bluetooth-searching"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Bluetooth Searching",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.809.538a.5.5 0 0 1 .545.108l2.5 2.5a.5.5 0 0 1 0 .708L6.707 6l2.147 2.146a.5.5 0 0 1 0 .708l-2.5 2.5A.5.5 0 0 1 5.5 11V7.207L3.854 8.854a.5.5 0 1 1-.708-.708L5.293 6 3.146 3.854a.5.5 0 1 1 .708-.708L5.5 4.793V1a.5.5 0 0 1 .309-.462Zm.691 6.67L7.793 8.5 6.5 9.793V7.207Zm0-2.415V2.207L7.793 3.5 6.5 4.793Zm3.561-.561a.5.5 0 0 1 .707 0 2.5 2.5 0 0 1 0 3.537.5.5 0 0 1-.706-.708 1.5 1.5 0 0 0 0-2.122.5.5 0 0 1 0-.707ZM8.5 6a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const L = /* @__PURE__ */ s(c, [["render", u]]);
export {
  L as default
};
//# sourceMappingURL=bluetooth-searching.js.map
